module.exports = __webpack_public_path__ + "media/assets/badges/Goodfirms-91b1f70be0c26181f7d82f9b947adb53.svg";